export const QUALITY_DASHBOARD_MODULE_ACTIONS = {
  overview: [
    { label: "Open Requests", to: "/auction/qa/dashboard/requests", primary: true },
    { label: "Submit Report", to: "/auction/qa/dashboard/completed", primary: false },
  ],
  open_requests: [
    { label: "Open Requests", to: "/auction/qa/dashboard/requests", primary: true },
    { label: "Submit Report", to: "/auction/qa/dashboard/completed", primary: false },
  ],
  quotations: [
    { label: "My quotations", to: "/auction/qa/dashboard/requests?filter=quoted", primary: true },
    { label: "Submit Quote", to: "/auction/qa/dashboard/requests?filter=pending", primary: false },
  ],
  inspections: [
    { label: "Active inspections", to: "/auction/qa/dashboard/inspections", primary: true },
    { label: "Submit Report", to: "/auction/qa/dashboard/completed", primary: false },
  ],
  reports: [
    { label: "Submit Report", to: "/auction/qa/dashboard/completed", primary: true },
    { label: "Open Requests", to: "/auction/qa/dashboard/requests", primary: false },
  ],
  completed: [
    { label: "View completed", to: "/auction/qa/dashboard/completed", primary: true },
    { label: "Open Requests", to: "/auction/qa/dashboard/requests", primary: false },
  ],
  quality_metrics: [
    { label: "View metrics", to: "/auction/qa/dashboard/module/quality-metrics", primary: true },
    { label: "Notifications", to: "/notifications", primary: false },
  ],
};

export function getQualityDashboardModuleActions(moduleKey) {
  return QUALITY_DASHBOARD_MODULE_ACTIONS[moduleKey] || QUALITY_DASHBOARD_MODULE_ACTIONS.overview;
}

export const QUALITY_DASHBOARD_MODULE_ROUTES = {
  overview: "/auction/qa/dashboard",
  open_requests: "/auction/qa/dashboard/module/open-requests",
  quotations: "/auction/qa/dashboard/module/quotations",
  inspections: "/auction/qa/dashboard/module/inspections",
  reports: "/auction/qa/dashboard/module/reports",
  completed: "/auction/qa/dashboard/module/completed",
  quality_metrics: "/auction/qa/dashboard/module/quality-metrics",
};
